import React, { useEffect, useState } from "react";
import { useLoader } from "../../../utils/LoaderUtils";
import { showError, showSuccess } from "../../../utils/toastUtils";
import StoreAPI from "../../../api/StoreApi";
import { useLocation, useParams } from "react-router-dom";
import StoreAdminAPI from "../../../api/StoreAdminApi";

function ChangePassword() {
  const location = useLocation();
  const { name } = location.state || {};

  const { id } = useParams();
  const { showLoader, hideLoader } = useLoader();
  const [isLoading, setIsLoading] = useState(false);

  const [formData, setFormData] = useState({
    new_password: "",
    confirm_password: "",
  });

  const [errors, setErrors] = useState({});

  useEffect(() => {
    document.title = "Change Password | AxeSell Ecommerce Solution";
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const validate = () => {
    const newErrors = {};

    if (!formData.new_password) {
      newErrors.new_password = "New password is required.";
    } else if (formData.new_password.length < 6) {
      newErrors.new_password =
        "New password must be at least 6 characters long.";
    }

    if (!formData.confirm_password) {
      newErrors.confirm_password = "Confirm password is required.";
    } else if (formData.confirm_password.length < 6) {
      newErrors.confirm_password =
        "Confirm password must be at least 6 characters long.";
    }

    if (
      formData.new_password &&
      formData.confirm_password &&
      formData.new_password !== formData.confirm_password
    ) {
      newErrors.submitError = "New password and confirm password do not match.";
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    showLoader();
    setIsLoading(true);
    e.preventDefault();

    if (!validate()) {
      setIsLoading(false);
      hideLoader();
      return;
    }

    try {
      const res = await StoreAdminAPI.updatePassword(id, formData);
      if (res.code === 200) {
        showSuccess(res.message);
      } else {
        showError(res.message);
      }
    } catch (err) {
      showError(err.response?.data?.message || "Something went wrong");
    } finally {
      setIsLoading(false);
      hideLoader();
    }
  };

  return (
    <>
      <div className="content">
        <div className="page-header">
          <div className="page-title">
            <h4>Change Admin Password</h4>
            <h6>Ensure account remains protected by updating password.</h6>
          </div>
        </div>
        {/* /product list */}
        <form method="post" onSubmit={handleSubmit}>
          <div className="row">
            <div className="col-md-6">
              <div className="card">
                <div className="card-header">
                  <h4>Update Password of {name}</h4>
                </div>
                <div className="card-body profile-body">
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <div className="mb-3">
                        <label className="form-label">
                          New Password <span className="text-danger">*</span>
                        </label>
                        <input
                          type="password"
                          name="new_password"
                          className="form-control"
                          placeholder="Enter New password"
                          value={formData.new_password}
                          autoComplete="new-password"
                          onChange={handleChange}
                        />
                        {errors.new_password && (
                          <span className="errors text-danger">
                            {errors.new_password}
                          </span>
                        )}
                      </div>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-lg-12 col-sm-12">
                      <label className="form-label">
                        Confirm Password <span className="text-danger">*</span>
                      </label>
                      <input
                        type="password"
                        name="confirm_password"
                        className="form-control"
                        placeholder="Enter Confirm password"
                        value={formData.confirm_password}
                        autoComplete="confirm-password"
                        onChange={handleChange}
                      />
                      {errors.confirm_password && (
                        <span className="errors text-danger">
                          {errors.confirm_password}
                        </span>
                      )}
                    </div>
                  </div>
                </div>
                <div className="card-footer">
                  <div className="row">
                    <div className="col-12 d-flex">
                      {!isLoading && (
                        <button
                          type="submit"
                          id="submitBtn"
                          className="btn btn-primary shadow-none"
                        >
                          Update Password
                        </button>
                      )}
                    </div>
                    {errors.submitError && (
                      <span className="errors text-danger">
                        {errors.submitError}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </form>
      </div>
    </>
  );
}

export default ChangePassword;
